import { createRouter, createWebHistory } from 'vue-router';

// Views
import HomePage from '../views/HomePage.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
  },
  {
    path: '/select-risk',
    name: 'RiskSelection',
    component: () => import('@/views/RiskSelectionView.vue')
  },
  {
    path: '/portfolio',
    name: 'PortfolioForm',
    component: () => import('@/views/PortfolioForm.vue')
  },
  {
    path: '/compare',
    name: 'PerformanceCompare',
    component: () => import('../views/PerformanceCompare.vue'),
  },
  {
    path: '/next',
    name: 'ResultsNextSteps',
    component: () => import('../views/ResultsNextSteps.vue'),
  },
  {
    path: '/pro',
    name: 'SpeakToPro',
    component: () => import('../views/SpeakToPro.vue'), 
  },
  {
    path: '/benchmarks',
    name: 'BenchmarkReports',
    component: () => import('../views/BenchmarkReports.vue'), 
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  // 🟢 NEW: Global Scroll Behavior
  // This ensures every page navigation snaps to the top
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, behavior: 'smooth' };
    }
  },
});

export default router;